module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/7d9107cdc32567399cc994df1e3767c0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/dropdown-up.svg
// module id = wfBL
// module chunks = 1